<template>
  <div >
    <TreeView v-if="data"
          ref="tree"
          :data="data"
          :prependIconClass="prependIconClass"
          :defaultIconClass="defaultIconClass"
          :iconClassProp="iconClassProp"
          :showIcons="showIcons"
          :initialSelection="initialSelection"
          :nodeKeyProp="nodeKeyProp"
          :nodeChildrenProp="nodeChildrenProp"
          :nodeLabelProp="nodeLabelProp"
          v-model="selection"
          :query="query"
          :recordsWithChosenFilters="recordsWithChosenFilters"
          :multiSelect="multiSelect"
          @childNodeMultiSelect="childNodeMultiSelect"
              @details = "showDetails"
        >

      </TreeView>
<!--    </div>-->
<!--    </VBox>-->
  </div>
</template>

<script>
import TreeView from "@/components/tree/TreeView";
import VBox from "@/components/VBox";
import Events from "@/utils/Events";

export default {
  name: "TreeViewCard",
  components: {VBox, TreeView},
  props:{
    recordsWithChosenFilters: {default: null},
    multiSelect: {default: null},
    query: {default: ""},
    title:{
      type: String,
      required: false
    },
    data: {
      type: Array,
      required: true
    },
    autoSize: {
      type: Boolean,
      default: false
    },
    alternateHeight: {
      type: Number,
      default: 200
    },
    breakpoint: {
      type: String,
      required: 'sm'
    },

    // class added to every icon no matter what
    prependIconClass: {
      type: String,
      default: null
    },
    // default icon if node icon is not specified
    defaultIconClass: {
      type: String,
      default: null
    },
    // where to search for node icon
    iconClassProp: {
      type: String,
      default: "icon"
    },
    // show icons
    showIcons: {
      type: Boolean,
      default: false
    },
    initialSelection: {
      type: Object,
      default: null
    },
    nodeKeyProp: {
      type: String,
      default: 'id'
    },
    nodeChildrenProp: {
      type: String,
      default: 'children'
    },
    nodeLabelProp: {
      type: String,
      default: 'name'
    },
  },
  methods:{
    expand(levels = 1){
      this.$refs.tree.expand(levels);
    },
    childNodeMultiSelect(node, isSelected) {
      this.$emit(Events.treeViewNodeMultiSelect, node, isSelected)
    },
    showDetails(data) {
      this.$emit("details", data);
    },

  },

  watch:{
    selection: function (newVal){
      this.$emit("change", newVal);
    },
    data: function (newVal){
      setTimeout(() => {
        this.$emit("change", this.selection);
      });
    },
    initialSelection: function (newVal){
    }
  },
  model:{
    event: 'change',
    prop: 'initialSelection'
  },
  data: () => {
    return {
      selection:null
    }
  }
}
</script>

<style scoped>
  .overflow-y {
    overflow-y: auto;
  }
</style>